module.exports = __webpack_public_path__ + "img/icon_office.38059846.svg";